import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_FHIR = {
    vv1: {
        fetchFhir: { method: HttpMethod.POST, path: '/v1/fhir/test' },
    }
};
//# sourceMappingURL=apis.js.map